/* eslint-disable react/no-multi-comp */

import Helper from "../../shared/modules/Helper";
import PropTypes from "prop-types";
import React from "react";

const NonMemberSummary = ({cartTotals, promos}) => {
  const {
    "item_count": itemCount,
    "final_total": finalTotal,
    "total_of_promotional_discounts": totalOfPromotionalDiscounts,
    subtotal
  } = cartTotals;

  const displayGiftWithPurchasePromoLineItem = promo => (
    <div className="gwp-line-item">
      <div>
        {promo.description}
      </div>
    </div>
  );

  const displayPercentDiscountPromoLineItem = promo =>
    totalOfPromotionalDiscounts > 0 &&
      <div className="line-item primary">
        <div className="left">
          {promo.description}
        </div>
        <div className="right primary">
          {`-$${Helper.formatPriceCents(totalOfPromotionalDiscounts)}`}
        </div>
      </div>;

  return (
    <div className="summary cart-block">
      <div className="header">
        <div className="title">
          Summary
        </div>
      </div>
      <div className="item-rewards-block">
        <div className="line-item">
          <div className="left">
            Items (
            {itemCount}
            )
          </div>
        </div>

        <div className="line-item">
          <div className="left">
            Shipping Cost
          </div>
          <div className="right primary">
            FREE
          </div>
        </div>
      </div>

      <div className="line-item">
        <div className="left">
          Subtotal
          <div className="tax-detail">
            *Sales Tax May Apply
          </div>
        </div>
        <div className="right">
          {`$${Helper.formatPriceCents(subtotal)}`}
        </div>
      </div>

      {
        promos &&
        promos.length > 0 &&
        promos[0].kind === "percent_off_dollar_threshold" &&
        displayPercentDiscountPromoLineItem(promos[0])
      }

      <div className="line-item total">
        <div className="left">
          Total
        </div>
        <div className="right">
          {`$${Helper.formatPriceCents(finalTotal)}`}
        </div>
      </div>

      {
        promos &&
        promos.length > 0 &&
        promos[0].kind === "gift_with_purchase" &&
        displayGiftWithPurchasePromoLineItem(promos[0])
      }
    </div>
  );
};

NonMemberSummary.propTypes = {
  "cartTotals": PropTypes.object.isRequired,
  "promos": PropTypes.array.isRequired
};

export default NonMemberSummary;
